export const DEPLOY_EXTERNAL = 'external_service'
export const DEPLOY_LOCAL_BINARY = 'local_binary'
export const DEPLOY_DOCKER = 'docker'
export const DEFAULT_GUI_PORT = 8889
